export const parseTourLink = (link: string, slug?: string) => {
  const linkSlug = link.replace(/(.+\/)|(\?.+)/g, '');
  if (slug && linkSlug !== slug) return false;
  const res = new URLSearchParams(link.replace(/(.+\?)/, '?'));
  return { s: res.get('s'), x: Number(res.get('x')), y: Number(res.get('y')) };
};
export const checkIsFavourite = (products = [], product, mode = 0) => {
  if (mode === 0) {
    return products?.find((p) => p.id === product.id);
  } else {
    return products?.find((p) => p.id === product.eCommerceProductId);
  }
};

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return null;

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const safeUrl = (url: string) => {
  if (!url.includes('http')) return `http://${url}`;
  return url;
};
